import { render, staticRenderFns } from "./SettingsMenuList.vue?vue&type=template&id=c5754936&scoped=true&"
import script from "./SettingsMenuList.vue?vue&type=script&lang=js&"
export * from "./SettingsMenuList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenuList.vue?vue&type=style&index=0&id=c5754936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5754936",
  null
  
)

export default component.exports